<template>
  <v-navigation-drawer
    v-model="toggle"
    fixed app>
    <v-toolbar flat dark :color="$root.themeColor" class="toolbar">
      <router-link :to="{ name: 'Dashboard' }">
        <img src="static/logo1.png" width="36px"></img>
      </router-link>
      <router-link :to="{ name: 'Dashboard' }" class="text">
        Stratis Inventory
      </router-link>
    </v-toolbar>
    <v-list>
      <v-list-item @click="changeRoute('Dashboard', 1)">
        <v-list-item-action>
          <v-icon>dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 1}, 'item-title' ]">Dashboard</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('Calendar', 2)">
        <v-list-item-action>
          <v-icon>calendar_today</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 2}, 'item-title' ]">Calendar</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('Groups', 8)">
        <v-list-item-action>
          <v-icon>group_work</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 8}, 'item-title' ]">Groups</v-list-item-title>
      </v-list-item>
      <v-list-item @click="changeRoute('ServersList', 9)">
        <v-list-item-action>
          <v-icon>dns</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 9}, 'item-title' ]">Servers</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('instances', 10)">
        <v-list-item-action>
          <v-icon>border_all</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 10}, 'item-title' ]">Instances</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('projects', 12)">
        <v-list-item-action>
          <v-icon>book</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 12}, 'item-title' ]">Projects</v-list-item-title>
      </v-list-item>


      <v-list-item @click="changeRoute('awx', 13)">
        <v-list-item-action>
          <v-icon>book</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 13}, 'item-title' ]">AWX</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('Blacklist', 11)">
        <v-list-item-action>
          <v-icon>block
          </v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 11}, 'item-title' ]">Blacklist</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('SmtpInput', 14)">
        <v-list-item-action>
          <v-icon>block
          </v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 14}, 'item-title' ]">SmtpInput</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('jschemas', 15)">
        <v-list-item-action>
          <v-icon>block
          </v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 15}, 'item-title' ]">jschemas</v-list-item-title>
      </v-list-item>

      <v-list-item @click="changeRoute('Mailbox', 3)">
        <v-list-item-action>
          <v-icon>inbox</v-icon>
        </v-list-item-action>
        <v-list-item-title :class="[{'active': selectedIndex === 3}, 'item-title' ]">Mailbox</v-list-item-title>
      </v-list-item>

      <v-list-group
        prepend-icon="pageview">
        <v-list-item slot="activator">
          <v-list-item-title class="item-title">Widgets</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('Social', 4)">
          <v-list-item-action>
            <v-icon>group</v-icon>
          </v-list-item-action>
          <v-list-item-title :class="[{'active': selectedIndex === 4}, 'item-title' ]">Social</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('Chart', 5)">
          <v-list-item-action>
            <v-icon>bar_chart</v-icon>
          </v-list-item-action>
          <v-list-item-title :class="[{'active': selectedIndex === 5}, 'item-title' ]">Charts</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('Media', 6)">
          <v-list-item-action>
            <v-icon>perm_media</v-icon>
          </v-list-item-action>
          <v-list-item-title :class="[{'active': selectedIndex === 6}, 'item-title' ]">Media</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group
        prepend-icon="select_all">
        <v-list-item slot="activator">
          <v-list-item-title class="item-title">Overlays</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('Snackbar', 7)">
          <v-list-item-action>
            <v-icon>event_note</v-icon>
          </v-list-item-action>
          <v-list-item-title :class="[{'active': selectedIndex === 7}, 'item-title' ]">Snackbar</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group
        prepend-icon="fingerprint">
        <v-list-item slot="activator">
          <v-list-item-title class="item-title">Authorization</v-list-item-title>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'Error', params: { errorCode: '403' } })">
          <v-list-item-action>
            <v-icon>cancel</v-icon>
          </v-list-item-action>
          <v-list-item-title class="item-title">403</v-list-item-title>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'Error', params: { errorCode: '404' } })">
          <v-list-item-action>
            <v-icon>cancel</v-icon>
          </v-list-item-action>
          <v-list-item-title class="item-title">404</v-list-item-title>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'Error', params: { errorCode: '500' } })">
          <v-list-item-action>
            <v-icon>cancel</v-icon>
          </v-list-item-action>
          <v-list-item-title class="item-title">500</v-list-item-title>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'Login' })">
          <v-list-item-action>
            <v-icon>cancel</v-icon>
          </v-list-item-action>
          <v-list-item-title class="item-title">Login</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group
        prepend-icon="account_circle">
        <v-list-item slot="activator">
          <v-list-item-title class="item-title">Users</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="(admin, i) in admins"
          :key="i"
          @click="">
          <v-list-item-action>
            <v-icon v-text="admin[1]"></v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="admin[0]"></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    toggle: {
        type: Boolean,
        required: false,
        default: true
    }
  },

  data() {
    return {
      selectedIndex: 1,
      admins: [
        ['Management', 'people_outline'],
        ['Settings', 'settings']
      ]
    }
  },

  methods: {
    changeRoute(routeName, selectedIndex) {
      this.selectedIndex = selectedIndex;
      this.$router.push({ name: routeName });
    }
  }
}
</script>

<style>
  .toolbar {
    font-weight: bold;
    font-size: 18px;
  }

  .toolbar .text {
    padding-left: 15px;
    color: white;
    text-decoration:none;
  }

  .item-title {
    font-size: 17px;
    font-weight: 500;
  }
  .item-sub-title {
    font-size: 15px;
    font-weight: 500;
  }

  .active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/NavigationDrawer.vue